import { createApiInstance } from '@/infrastructure/apis/apiInstance'

const apiDetailsApi = {
  index: async () => {
    const response = await createApiInstance().get('/ApiDetails')
    return response.data
  },
}
export default apiDetailsApi
